import type { Locale } from "@sss/shared";
import { en } from "./locales/en";
import { fr } from "./locales/fr";
import { de } from "./locales/de";
import { es } from "./locales/es";
import { pl } from "./locales/pl";
import { zhHans } from "./locales/zh-Hans";

/**
 * The shape every locale must fill, taken from English rather than declared
 * separately — so `en.ts` is the only place a new string is *invented*, and
 * the other four fail to compile until they answer it.
 */
export type Messages = typeof en;

export const MESSAGES: Record<Locale, Messages> = { en, fr, de, es, pl, "zh-Hans": zhHans };

/**
 * What each language calls itself. Not part of the message files: a
 * language picker shows every option in its own language, not translated
 * into the one currently active, so there is exactly one right answer per
 * locale rather than one per locale *pair*.
 */
export const LOCALE_NAMES: Record<Locale, string> = {
  en: "English",
  fr: "Français",
  de: "Deutsch",
  es: "Español",
  pl: "Polski",
  "zh-Hans": "简体中文",
};
